import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { Button, Col, Form, Input, Row, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import SelectTerritorialUnitsCode from "../../../../components/selects/SelectTerritorialUnitsCode";
import { SelectProductType } from "../../../../components/selects";
import GeneralSelect from "../../../../components/selects/general/GeneralSelect";
import { EntBasicHB } from "../../../../models/handBooks/basicHB";
import { EntDirectoryInfoName } from "../../../../models/directoryInfoName";
import { EntInitialFilter } from "../../../../models/filters/initialFilter";
import { useLazyGetLegalFormListQuery } from "../../../../redux/api/handBooksApi/organic/legalFormApi";
import { useLazyGetIndustryTypeListQuery } from "../../../../redux/api/handBooksApi/organic/industryTypeApi";
import { useLazyGetRegisterStatusListQuery } from "../../../../redux/api/handBooksApi/organic/registerStatusApi";

interface IProps {
  formField: any;
  form: any;
  onReset: () => void;
  onSearch: () => void;
}

export const FilterOrganicproducers = (props: IProps) => {
  const { t } = useTranslation();
  const [selectedRegionId, setSelectedRegionId] = useState<number|null>(null);
  const [selectedAreaCode, setSelectedAreaCode] = useState<string|null>(null);

  return (
	<Form form={ props.form } layout='vertical'>
	  <Row gutter={ [8, 8] }>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label="Название компании"
			name={ props.formField.companyName }
		  >
			<Input placeholder="Введите название компании"/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label="Юридическая форма"
			name={ props.formField.legalFormId }
		  >
			<GeneralSelect<EntDirectoryInfoName, EntInitialFilter>
			  queryHook={ useLazyGetLegalFormListQuery }
			  initialFilter={ new EntInitialFilter() }
			/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label="Тип отрасли"
			name={ props.formField.industryTypeId }
		  >
			<GeneralSelect<EntDirectoryInfoName, EntInitialFilter>
			  queryHook={ useLazyGetIndustryTypeListQuery }
			  initialFilter={ new EntInitialFilter() }
			/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label="Адрес"
			name={ props.formField.address }
		  >
			<Input placeholder="Введите адрес"/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label="Дата регистрации"
			name={ props.formField.registrationDate }
		  >
			<Input type="date" placeholder="Выберите дату"/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label="Статус"
			name={ props.formField.statusId }
		  >
			<GeneralSelect<EntBasicHB, EntInitialFilter>
			  queryHook={ useLazyGetRegisterStatusListQuery }
			  initialFilter={ new EntInitialFilter() }
			/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label={ t('titles.territorial_unit_area') }
			name={ props.formField.regionId }
		  >
			<SelectTerritorialUnitsCode
			  parentId={ 1 }
			  onChange={ (value, option: any) => {
				setSelectedRegionId(Number(value));
				setSelectedAreaCode(null);
				props.form.setFieldsValue({
				  [props.formField.regionId]: value,
				  [props.formField.areaId]: null,
				  [props.formField.territorialUnitId]: null,
				});
			  } }
			/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label={ t('titles.territorialUnitDistricts') }
			name={ props.formField.areaId }
		  >
			<SelectTerritorialUnitsCode
			  type={ ['AREA', 'CITY_OF_REPUBLICAN_SIGNIFICANCE'] }
			  parentId={ selectedRegionId }
			  onChange={ (value, option: any) => {
				setSelectedAreaCode(option?.data?.code || null);
				props.form.setFieldsValue({
				  [props.formField.areaId]: value,
				  [props.formField.territorialUnitId]: null,
				});
			  } }
			/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label={ t("titles.territorialUnitVillage") }
			name={ props.formField.territorialUnitId }
		  >
			<SelectTerritorialUnitsCode areaCode={ selectedAreaCode }/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label="Вид продукции"
			name={ props.formField.productTypeId }
		  >
			<SelectProductType/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 24 } md={ 24 } lg={ 24 }>
		  <div style={ { marginTop: 4 } }>
			<Button
			  type="primary"
			  shape="default"
			  icon={ <SearchOutlined/> }
			  style={ { marginRight: 8 } }
			  onClick={ props.onSearch }
			>
			  { t('general.search') }
			</Button>
			<Button
			  type="link"
			  onClick={ props.onReset }
			  style={ { color: "orange" } }
			>
			  { t('general.reset') }
			</Button>
		  </div>
		</Col>
	  </Row>
	</Form>
  );
};
